<script>
    export let size = 24
    export let color = '#00669E'
    export let style = ''
    export let title = null
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 512 512"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        d="M376,144c-3.92,52.87-44,96-88,96s-84.15-43.12-88-96c-4-55,35-96,88-96S380,90,376,144Z"
        style={`fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:32px`}
    ></path>
    <path
        d="M288,304c-87,0-175.3,48-191.64,138.6-2,10.92,4.21,21.4,15.65,21.4H464c11.44,0,17.62-10.48,15.65-21.4C463.3,352,375,304,288,304Z"
        style={`fill:none;stroke:${color};stroke-miterlimit:10;stroke-width:32px`}
    ></path>
    <line
        x1="88"
        y1="176"
        x2="88"
        y2="288"
        style={`fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:32px`}
    ></line>
    <line
        x1="144"
        y1="232"
        x2="32"
        y2="232"
        style={`fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:32px`}
    ></line>
</svg>
